import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import React from "react";
import {ChevronDown} from "lucide-react";
import withStyles from '@mui/styles/withStyles';
import Input from "@mui/material/Input";
import {connect} from "react-redux";
import {changeLanguage, changeUserLanguage} from "actions/languageAction";
import { sortBy } from "lodash";
import {color, font, type} from "common/tokens";

const styles = () => ({
  icon: {
    color: color.TEXT_MUTED,
    width: 16,
    height: 16,
    top: 'calc(50% - 8px)',
    right: 0,
  },
  inputRoot: {
    'label + &': {
      marginTop: 0,
    },
  },
  input: {
    ...type.meta,
    fontWeight: font.REGULAR,
    color: color.TEXT_MUTED,
    padding: 0,
    paddingRight: 18,
  },
  menuItem: {
    ...type.meta,
    fontWeight: font.REGULAR,
  },
});


const LanguageDropdown = ({
                            classes, activeLanguageCode = 'en', changeUserLanguage, supportedLanguages = []
                          }) => {
  const languages = sortBy(
    supportedLanguages.filter(language => language.isActive || language.languageCode === activeLanguageCode),
    'languageCode'
  );

  return (
    <Select
      labelId="language-selection"
      id="language-selection"
      variant="standard"
      onChange={(e) => changeUserLanguage(e.target.value)}
      input={<Input classes={{root: classes.inputRoot, input: classes.input}} inputProps={{'aria-label': 'language'}}
                    disableUnderline/>}
      value={activeLanguageCode}
      IconComponent={ChevronDown}
      classes={{icon: classes.icon}}
    >
      {languages.map(language => (
        <MenuItem key={language.languageCode} value={language.languageCode} className={classes.menuItem}>
          {language.language}
        </MenuItem>
      ))}
    </Select>
  );
};


const mapStateToProps = ({language: {supportedLanguages, activeLanguageCode}}) => ({
  supportedLanguages, activeLanguageCode
});

const mapPropsToActions = {changeLanguage, changeUserLanguage};

export default connect(mapStateToProps, mapPropsToActions)(withStyles(styles)(LanguageDropdown));
